import { COLOR_PALETTE } from 'constants/ui';
import { getConditionalObject } from 'utils/data';

// Dark: the light pale RED[1] failed-row tint would render near-white on the dark canvas; use the
// error soft tint. Light keeps RED[1]. Non-failed rows use the normal panel surface.
const getRowBackground = (palette, isFailed) => {
  if (!isFailed) {
    return palette.background.paper;
  }

  return palette.mode === 'dark' ? palette.error.soft : COLOR_PALETTE.RED[1];
};

export const getRowWrapperStyles =
  ({ isFailed, isExpanded }) =>
  ({ palette }) => ({
    display: 'flex',
    flexDirection: 'column',
    borderRadius: '8px',
    border: `1px solid ${isFailed ? COLOR_PALETTE.RED[2] : palette.border.default}`,
    backgroundColor: getRowBackground(palette, isFailed),
    overflow: 'hidden',

    '&:hover': {
      borderColor: isFailed ? COLOR_PALETTE.RED[5] : COLOR_PALETTE.BLUE[4],
    },

    ...getConditionalObject(isExpanded, () => ({
      borderColor: isFailed ? COLOR_PALETTE.RED[5] : COLOR_PALETTE.BLUE[5],
    })),
  });

export const rowMainStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '14px',
  padding: '10px 14px',
  cursor: 'pointer',
};

export const getStatusIconStyles =
  ({ backgroundColor }) =>
  ({ palette }) => ({
    width: '28px',
    height: '28px',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    backgroundColor,
    color: palette.common.white,
    border: `2px solid ${palette.background.paper}`,
    boxShadow: palette.shadow?.s,
  });

// Slimmer node used by the step timeline (StepNavRow): a small crisp dot that
// reads as a marker over the connector. Keeps the 2px surface ring so it stays
// legible, but drops the elevation that makes the run-history icon look chunky.
export const getCompactStatusIconStyles =
  ({ backgroundColor }) =>
  ({ palette }) => ({
    width: '18px',
    height: '18px',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    backgroundColor,
    color: palette.common.white,
    border: `2px solid ${palette.background.paper}`,
  });

export const rowBodyStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '2px',
  flex: 1,
  minWidth: 0,
};

export const rowTitleRowStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '10px',
  minWidth: 0,
};

export const rowMetaStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  color: ({ palette }) => palette.text.dark,
  flexWrap: 'wrap',
};

export const rowTrailingStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '14px',
};

export const expandToggleStyles = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '24px',
  height: '24px',
  borderRadius: '6px',
  color: ({ palette }) => palette.text.secondary,
  cursor: 'pointer',

  '&:hover': {
    backgroundColor: ({ palette }) => palette.background.disabled,
  },
};

export const dotSeparatorStyles = {
  display: 'inline-block',
  width: '3px',
  height: '3px',
  borderRadius: '50%',
  backgroundColor: COLOR_PALETTE.GRAY[6],
};
